import { FormattedMessage, useIntl } from 'react-intl'
import { Wrapper } from './GuestField.styles'
import Price from 'components/shared/Price'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Input from 'components/shared/Input'
import InlineTextList from 'components/shared/InlineTextList'
import { useResolutions } from 'store/resolutions'
import { GuestFieldProps } from './GuestField.types'

const GuestField = ({ data, index, onChange }: GuestFieldProps) => {
    const { formatMessage } = useIntl()
    const { isTablet } = useResolutions()

    const {
        price,
        firstName,
        lastName,
        isFirstNameError,
        isLastNameError,
        tickets,
    } = data
    const { person, zone, ticketType } = tickets[0] || {}
    const ticketsNumber = tickets.length

    return (
        <Wrapper gap={24}>
            <Box
                direction="row"
                justify="space-between"
                align="baseline"
                gap={16}
                isFullWidth
            >
                <Box
                    direction="row"
                    justify="flex-start"
                    align="baseline"
                    gap={16}
                    isFullWidth
                >
                    <Text
                        variant={isTablet ? 'heading5' : 'heading4'}
                        color="grayscale_900"
                    >
                        <FormattedMessage
                            id="global.label.guest"
                            defaultMessage="_"
                        />{' '}
                        {index}
                    </Text>
                    {!isTablet && (
                        <Box
                            direction="row"
                            justify="flex-start"
                            align="baseline"
                            gap={4}
                        >
                            <InlineTextList
                                variant="bodySmall"
                                color="grayscale_800"
                                items={[person, zone, ticketType]}
                                hasNoWrapItems
                                gap={8}
                            />
                            {ticketsNumber > 1 && (
                                <Text variant="bodySmall" color="primary_500">
                                    {`(${ticketsNumber}x)`}
                                </Text>
                            )}
                        </Box>
                    )}
                </Box>
                <Box direction="row" gap={4} hasNoShrink>
                    {ticketsNumber > 1 && (
                        <Text variant="bodyStrong" color="secondary_500">
                            {ticketsNumber} x
                        </Text>
                    )}
                    <Price
                        value={price || null}
                        size="bodyStrong"
                        currencySize="bodyStrong"
                    />
                </Box>
            </Box>
            {isTablet && (
                <Box
                    direction="row"
                    justify="flex-start"
                    align="baseline"
                    mt={8}
                    gap={4}
                >
                    <InlineTextList
                        variant="body14"
                        color="grayscale_800"
                        items={[person, zone, ticketType]}
                        gap={8}
                    />
                    {ticketsNumber > 1 && (
                        <Text variant="bodySmall" color="primary_500">
                            {`(${ticketsNumber}x)`}
                        </Text>
                    )}
                </Box>
            )}
            <Box
                direction={['column', 'row']}
                mt={[16, 24]}
                gap={24}
                isFullWidth
            >
                <Input
                    id="firstName"
                    type="text"
                    label={formatMessage({
                        id: 'global.input.first_name_label',
                        defaultMessage: '_',
                    })}
                    value={firstName || ''}
                    onChange={(value) => onChange(value, 'firstName', index)}
                    testId="march-field-0-firstname"
                    isError={isFirstNameError}
                />
                <Input
                    id="lastName"
                    type="text"
                    label={formatMessage({
                        id: 'global.input.last_name_label',
                        defaultMessage: '_',
                    })}
                    value={lastName || ''}
                    onChange={(value) => onChange(value, 'lastName', index)}
                    testId="march-field-0-lastname"
                    isError={isLastNameError}
                />
            </Box>
        </Wrapper>
    )
}

export default GuestField
